import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, CheckCircleIcon } from 'lucide-react';
const testimonials = [{
  name: 'Carlos M.',
  location: 'Miami, FL',
  text: 'Wore it to a watch party and everyone kept asking about it. People just tap your sleeve and boom — your whole profile pops up. Got like 20 new followers that night alone.',
  rating: 5,
  product: 'USA Smart T-Shirt',
  date: 'Mar 2026'
}, {
  name: 'Sarah K.',
  location: 'Los Angeles, CA',
  text: "I'm a content creator and this is hands down the coolest merch I've ever owned. I linked my latest video and TikTok — my followers love tapping it when they see me in person.",
  rating: 5,
  product: 'Brazil Smart T-Shirt',
  date: 'Mar 2026'
}, {
  name: 'David R.',
  location: 'Houston, TX',
  text: "Got the 3-pack for me and my boys. We're all set for the World Cup. The fact that the stats and content update automatically without doing anything is what sold me.",
  rating: 5,
  product: '3-Pack Bundle',
  date: 'Apr 2026'
}];
export function SocialProofSection() {
  return <section id="testimonials" className="py-10 md:py-20 bg-brand-dark relative" data-id="element-539">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-540">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16" data-id="element-541">
          <span className="text-brand-cyan font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-542">
            Real Buyers, Real Experiences
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold" data-id="element-543">
            Hear It From Our Customers
          </h2>
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-12 md:mb-20" data-id="element-544">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="glass-card p-6 md:p-8 flex flex-col" data-id="element-545">
              {/* Stars */}
              <div className="flex gap-1 mb-4" data-id="element-546">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className={`w-4 h-4 ${j < t.rating ? 'fill-yellow-400 text-yellow-400' : 'fill-gray-600 text-gray-600'}`} data-id="element-547" />)}
              </div>

              {/* Review text */}
              <p className="text-gray-300 text-sm md:text-base leading-relaxed mb-6 flex-grow" data-id="element-548">
                "{t.text}"
              </p>

              {/* Reviewer info */}
              <div className="border-t border-white/5 pt-4" data-id="element-549">
                <div className="flex items-center justify-between mb-1" data-id="element-550">
                  <p className="font-bold text-white text-sm" data-id="element-551">{t.name}</p>
                  <div className="flex items-center gap-1" data-id="element-552">
                    <CheckCircleIcon className="w-3.5 h-3.5 text-green-400" data-id="element-553" />
                    <span className="text-[10px] text-green-400 font-bold uppercase tracking-wider" data-id="element-554">
                      Verified Buyer
                    </span>
                  </div>
                </div>
                <p className="text-xs text-gray-500" data-id="element-555">{t.location}</p>
                <div className="flex items-center justify-between mt-2" data-id="element-556">
                  <span className="text-[10px] text-brand-cyan font-medium" data-id="element-557">
                    {t.product}
                  </span>
                  <span className="text-[10px] text-gray-600" data-id="element-558">{t.date}</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Trust stats bar */}
        {/* Star rating line */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center gap-6" data-id="element-559">
          {/* Trustpilot-style badge */}
          <div className="inline-flex flex-col items-center gap-2 px-8 py-4 rounded-xl" style={{
          background: 'linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(0,0,0,0.2) 100%)',
          border: '1px solid rgba(255,255,255,0.08)'
        }} data-id="element-560">
            <div className="flex items-center gap-2" data-id="element-561">
              <StarIcon className="w-5 h-5 fill-green-400 text-green-400" data-id="element-562" />
              <span className="text-white font-bold text-lg tracking-wide" data-id="element-563">
                Trustpilot
              </span>
            </div>
            <div className="flex gap-0.5" data-id="element-564">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-green-400 text-green-400" data-id="element-565" />)}
            </div>
            <p className="text-xs text-gray-400" data-id="element-566">
              <span className="text-green-400 font-bold" data-id="element-567">Excellent</span> - 4.9
              out of 5 based on{' '}
              <span className="font-bold text-white" data-id="element-568">3.4k+</span> reviews
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}